import { useAuth0 } from "@auth0/auth0-react";

export function useSafeAccessToken() {
  const { getAccessTokenSilently, logout } = useAuth0();

  const getToken = async (options = {}) => {
    try {
      return await getAccessTokenSilently(options);
    } catch (err: any) {
      console.error("Auth0 token refresh failed:", err);

      const isCallbackRoute =
        typeof window !== "undefined" && window.location.pathname.includes("/callback");

      const isFatalRefreshIssue =
        err?.error === "invalid_grant" ||
        err?.error_description?.includes("Unknown or invalid refresh token");

      if (isFatalRefreshIssue && !isCallbackRoute) {
        console.warn("Fatal refresh issue — forcing re-login");
        await logout();
      }

      // For transient interactive errors (e.g., login_required, missing_refresh_token), just rethrow
      // and let a route guard or interceptor decide how to handle navigation once.
      throw err;
    }
  };

  return getToken;
}